import React, {useEffect, useState} from 'react';
import {Card, Divider, Typography} from 'antd';
import InterviewTable from './InterviewTable';
import {IFetchInterview} from './interface';
import {setInterview} from './getInterviewData';


type InterviewProps = {
  title: string;
};

const { Title } = Typography;

function InterviewRecruiting(props: InterviewProps) {
  const [fetchInterview, setFetchInterview] = useState<IFetchInterview[]>([]);
  const [interviewCurrentPage, setInterviewCurrentPage] = useState<number>(1);

  const { title } = props;

  useEffect(() => {
    document.title = title;
  }, [title]);

  useEffect(() => {
    setInterview(setFetchInterview);
  }, []);

  return (
      <Card style={{ marginTop: 25 }}>
        <Title
            level={4}
            style={{
              whiteSpace: 'normal',
              height: 'auto',
              color: '#0057FF',
            }}
        >
          Интервью руководителей с кандидатами (ГО и Регионы)
        </Title>
        <Divider />

        <InterviewTable
            fetchInterview={fetchInterview}
            currentPage={interviewCurrentPage}
            setCurrentPage={setInterviewCurrentPage}
        />
      </Card>
  );
}

export default InterviewRecruiting;
